<ng-container>
  <ng-container *ngIf="showQuoteCreationWarningMessage$ | async">
    <cx-message
      (closeMessage)="clearWarning()"
      [text]="'quote.commons.contractProductsInCartNote' | cxTranslate"
      [type]="globalMessageType.MSG_TYPE_WARNING"
      class="quick-order-successes-message"
      >
      <ul class="quick-order-successes">
        <li *ngFor="let contractProduct of (contractProductsInCreateQuoteEvent$ | async)" class="quick-order-warning-item">
          {{ contractProduct.name }}
        </li>
      </ul>
    </cx-message>
  </ng-container>
  <ng-container
    *ngIf="customCart as cart"
    [ngTemplateOutlet]="cartTemplate"
    [ngTemplateOutletContext]="{
      cart: cart,
      isCustom: true,
      isQuote: false,
      isSeller: false
    }"
  ></ng-container>
  <ng-container
    *ngIf="cart$ && !quote"
    [ngTemplateOutlet]="cartTemplate"
    [ngTemplateOutletContext]="{
      cart: cart$ | async,
      isCustom: false,
      isQuote: false,
      isSeller: false
    }"
  ></ng-container>
  <ng-container
    *ngIf="quote as quote"
    [ngTemplateOutlet]="cartTemplate"
    [ngTemplateOutletContext]="{
      cart: quote,
      isCustom: quoteIsReadOnly,
      isQuote: true,
      isSeller: quote.user.isSeller
    }"
  ></ng-container>
</ng-container>

<ng-template let-ctx #saveForLaterBtn>
  <button
    *ngIf="selectiveCartEnabled"
    class="btn btn-tertiary cx-sfl-btn"
    [disabled]="ctx.loading"
    (click)="saveForLater(ctx.item)"
    type="button"
  >
    {{ 'saveForLaterItems.saveForLater' | cxTranslate }}
  </button>
</ng-template>

<ng-template let-cart='cart' let-isCustom='isCustom' let-isSeller='isSeller' let-isQuote='isQuote' #cartTemplate>
  <ng-container *ngIf="entries$ | async as entries">
    <div *ngIf="getCartTotalItems(cart) > 0" class="cart-details-wrapper">
      <cx-cart-validation-warnings></cx-cart-validation-warnings>

      <h2 class="cx-total" *ngIf="!isCustom && !isQuote">
        {{ 'cartDetails.cartName' | cxTranslate: { code: cart.code } }}
      </h2>

      <cx-promotions
        *ngIf="showPromotions"
        [promotions]="
          (cart.appliedOrderPromotions || []).concat(
            cart.potentialOrderPromotions || []
          )
        "
      ></cx-promotions>

      <cx-cart-item-list
        [items]="entries"
        [cartId]="cart.code"
        [cartIsLoading]="!(cartLoaded$ | async)"
        [promotionLocation]="promotionLocation"
        [readonly]="isCustom"
        [options]="{
          isSaveForLater: false,
          optionalBtn: saveForLaterBtn,
          isQuote: isQuote,
          isSeller: isSeller
        }"
      ></cx-cart-item-list>
    </div>
  </ng-container>
</ng-template>
